import React from 'react';
import styled from 'styled-components';
import approachImage from '../../../assets/images/ProductSales/OurApproach.png'; // Replace with your image path

const FlowChart = () => {
  return (
    <Container>
      <div className="benefits container">
        <h4 className="solution-page-heading">Our Approach</h4>
        <Image src={approachImage} alt="Our Approach" /> {/* Responsive image */}
      </div>
    </Container>
  );
};

export default FlowChart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f8ff;
  font-family: "Poppins", system-ui;
  padding: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const Image = styled.img`
  margin: 20px 0;
  width: 100%;
  max-width: 1400px;

  border-radius: 8px;

  @media (max-width: 768px) {
    max-width: 80%;
  }

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;
